export function void0(_?: any) {
  return void 0;
}
